import { Component, OnDestroy, OnInit } from '@angular/core';
import { PrSidepanelService } from './pr-sidepanel.service';

@Component({
    selector: 'pr-sidepanel',
    templateUrl: './pr-sidepanel.component.html',
    styleUrls: ['./pr-sidepanel.component.scss'],
    standalone: false
})
export class PrSidepanelComponent implements OnInit, OnDestroy {
  constructor(private sidePanelService: PrSidepanelService) {}
  alive = true;
  opened = false;
  side: string = 'right';

  ngOnInit() {
    this.sidePanelService.openPanelSubject.subscribe(side => {
      this.opened = true;
      this.side = side;
    });
    this.sidePanelService.closePanelSubject.subscribe(
      () => (this.opened = false),
    );
  }

  confirmCloseSidePanel() {
    this.sidePanelService.closePanel();
    this.opened = false;
  }

  ngOnDestroy() {
    this.alive = false;
  }
}
